import { useRender } from 'redity'
import { getItems, KEY_COMPONENT } from '.'
import Notification from '../../components/Notification'

export default function Component() {
    useRender(KEY_COMPONENT)
    const items = getItems()
    return <Notification data={items} show={items.length > 0} />
}
